import React from 'react';
import { useTranslation } from 'react-i18next';
import { translationKeys } from '@gik/inkind-page/i18n/en';
import bemBlock from '@gik/core/utils/bemBlock';
import { PropsWithClassName } from '@gik/core/utils/ReactUtils';
import { RecipientInfoFieldSet, SectionTitleAndDescription } from '@gik/inkind-page';

export interface IRecipientInfoSectionProps {
  id?: string;
}

export const recipientInfoSectionBlockName = 'recipient-info-section';

const RecipientInfoSection: React.FC<PropsWithClassName<IRecipientInfoSectionProps>> = ({
  className,
  id,
}): JSX.Element => {
  const bem = bemBlock(recipientInfoSectionBlockName);
  const { t } = useTranslation();

  return (
    <SectionTitleAndDescription
      id={id}
      className={bem(null, null, className)}
      title={t(translationKeys.recipientInfoTitle)}
      description={t(translationKeys.recipientInfoDescription)}
      hasBlueBackground
    >
      <RecipientInfoFieldSet className={bem('fieldset')} />
    </SectionTitleAndDescription>
  );
};

export default RecipientInfoSection;
